import React from 'react'
import { useManageRoleStore } from '../components/manageRole/stateStore/manageRoleStore'
import { useSafeUserData } from '../stateStores/User'
import { FeedbackValues } from '../api/role/models/FeedbackDto'
import { InterviewForThisRoleValues } from '../api/role/models/CandidateConnectionDto'
import ToggleSwitch from './ToggleSwitch'

const FeedbackSection: React.FC = () => {
    const { user } = useSafeUserData()

    const candidateId = useManageRoleStore(
        (state) => state.selectedCandidateId,
    )!
    const candidate = useManageRoleStore()
        .getState()
        .candidates.find((c) => c.candidatePersonId === candidateId)
    const hiringManagerConnection = candidate?.connections.find(
        (c) => c.connectedPersonId === user.personId,
    )

    const feedbackValue = hiringManagerConnection?.feedback?.value
    const interviewValue = hiringManagerConnection?.interviewForThisRole

    const updateFeedbackValueForCandidate =
        useManageRoleStore().getState().updateFeedbackValueForCandidate
    const updateInterviewForCandidate =
        useManageRoleStore().getState().updateInterviewForCandidate
    const localUpdateFeedbackComment =
        useManageRoleStore().getState().localUpdateFeedbackComment
    const updateFeedbackCommentForCandidate =
        useManageRoleStore().getState().updateFeedbackCommentForCandidate

    const commentValue = hiringManagerConnection?.feedback?.comment ?? ''

    const handleFeedbackChange = (value: FeedbackValues) => {
        updateFeedbackValueForCandidate(candidateId, value)
    }

    const handleInterviewChange = (value: InterviewForThisRoleValues) => {
        updateInterviewForCandidate(candidateId, value)
    }

    const feedbackOptions: {
        value: FeedbackValues
        label: string
    }[] = [
        { value: FeedbackValues.WILL_WORK_WITH_AGAIN, label: 'Yes' },
        { value: FeedbackValues.WILL_NOT_WORK_WITH_AGAIN, label: 'No' },
        { value: FeedbackValues.MIGHT_WORK_WITH_AGAIN, label: 'Maybe' },
        { value: FeedbackValues.DO_NOT_KNOW_THEM, label: `Don't Know Them` },
    ]

    return (
        <div className="flex justify-between mb-2">
            <div className="flex flex-col">
                <div className="font-bold mb-1">Work with again?</div>
                <select
                    value={feedbackValue ?? ''}
                    onChange={(e) =>
                        handleFeedbackChange(e.target.value as FeedbackValues)
                    }
                    className="form-select text-sm px-3 py-1 rounded border-gray-300 shadow-sm"
                >
                    <option value="" disabled>
                        Select feedback
                    </option>
                    {feedbackOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label ?? option.value.replace(/_/g, ' ')}
                        </option>
                    ))}
                </select>

                {feedbackValue &&
                    feedbackValue !== FeedbackValues.WILL_NOT_WORK_WITH_AGAIN &&
                    feedbackValue !== FeedbackValues.HIDDEN && (
                        <div className="flex gap-4 mt-2">
                            <div className="font-bold my-2">Interview?</div>
                            <ToggleSwitch
                                checked={
                                    interviewValue ===
                                    InterviewForThisRoleValues.YES
                                }
                                onChange={(checked) =>
                                    handleInterviewChange(
                                        checked
                                            ? InterviewForThisRoleValues.YES
                                            : InterviewForThisRoleValues.NO,
                                    )
                                }
                            />
                        </div>
                    )}
            </div>
            <div>
                <div className="font-bold mb-1">Comments</div>
                <div>
                    <textarea
                        className="form-input text-area-input min-w-[300px] min-h-[70px]"
                        placeholder="Comment"
                        value={commentValue}
                        onChange={(e) =>
                            localUpdateFeedbackComment(
                                candidateId,
                                e.target.value,
                            )
                        }
                        onBlur={() =>
                            updateFeedbackCommentForCandidate(candidateId)
                        }
                    />
                </div>
            </div>
        </div>
    )
}

export default FeedbackSection
